import React from 'react';
import OverviewTab from './OverviewTab';
import CurriculumTab from './CurriculumTab';
import StudentsTab from './StudentsTab';
import ReviewsTab from './ReviewsTab';
import AnalyticsTab from './AnalyticsTab';

const CourseTabs = ({ activeTab, onTabChange, course, studentsData, formatCurrency }) => {
  const tabs = ['overview', 'curriculum', 'students', 'reviews', 'analytics'];

  return (
    <div className="bg-white rounded-xl sm:rounded-2xl shadow-lg mb-6 sm:mb-8 overflow-hidden">
      <div className="border-b border-gray-200">
        <nav className="flex -mb-px overflow-x-auto">
          {tabs.map((tab) => (
            <button
              key={tab}
              onClick={() => onTabChange(tab)}
              className={`flex-1 min-w-[120px] px-4 sm:px-6 py-3 text-center font-medium text-sm transition-all duration-300 whitespace-nowrap ${
                activeTab === tab
                  ? 'text-green-600 border-b-2 border-green-500 bg-green-50'
                  : 'text-gray-500 hover:text-gray-700 hover:bg-gray-50'
              }`}
            >
              {tab.charAt(0).toUpperCase() + tab.slice(1)}
              {tab === 'students' && studentsData?.pagination?.total > 0 && (
                <span className="ml-2 bg-green-100 text-green-800 text-xs px-2 py-1 rounded-full">
                  {studentsData.pagination.total}
                </span>
              )}
              {tab === 'students' && !studentsData?.pagination?.total && course.totalStudents > 0 && (
                <span className="ml-2 bg-green-100 text-green-800 text-xs px-2 py-1 rounded-full">
                  {course.totalStudents}
                </span>
              )}
              {tab === 'reviews' && course.feedbacks?.length > 0 && (
                <span className="ml-2 bg-green-100 text-green-800 text-xs px-2 py-1 rounded-full">
                  {course.feedbacks.length}
                </span>
              )}
            </button>
          ))}
        </nav>
      </div>

      <div className="p-6 sm:p-8">
        {activeTab === 'overview' && <OverviewTab course={course} />}
        {activeTab === 'curriculum' && <CurriculumTab course={course} />}
        {activeTab === 'students' && (
          <StudentsTab 
            studentsData={studentsData} 
            formatCurrency={formatCurrency}
            onPageChange={studentsData?.onPageChange}
            currentPage={studentsData?.currentPage}
          />
        )}
        {activeTab === 'reviews' && <ReviewsTab course={course} />}
        {activeTab === 'analytics' && <AnalyticsTab course={course} />}
      </div>
    </div>
  );
};

export default CourseTabs;